const appInfo = {
    title: 'Hyper Gestione Esigenze Sociali',
    shortTitle: 'Hyper GES'
};
export default appInfo;

